import React from 'react';
import { Field } from 'react-final-form';
import TextField from './text_field';
import SelectField from './suggest_field';

/**
 * A single labelled option for select fields.
 */
export interface LabelledOption {
  Label: string;
  Value: string;
}

/**
 * A field definition derived from backend settings, used for dynamic form rendering.
 * Matches the shape returned by GetAllSystemSettings.
 */
export interface AgenticField {
  name: string;
  label: string;
  secret: boolean;
  options: LabelledOption[];
  hasOptions: boolean;
  placeholder: string | null;
  section: string | null;
}

/**
 * Renders a dynamic form field based on backend field definition.
 * Follows the same pattern as connections.js:94-112.
 */
const DynamicField = ({ field }: { field: AgenticField }) => {
  const fieldProps = {
    name: field.name,
    label: field.label,
    fullWidth: true,
    placeholder: field.placeholder || undefined,
  };

  if (field.hasOptions) {
    return (
      <Field
        component={SelectField as any}
        options={field.options.map((x) => ({ label: x.Label, value: x.Value }))}
        {...fieldProps}
      />
    );
  }

  if (field.secret) {
    return (
      <Field
        component={TextField as any}
        type="password"
        inputProps={{
          onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
            if (e.currentTarget.type === 'password') {
              e.currentTarget.type = 'text';
            }
          },
          onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            e.currentTarget.type = 'password';
          },
        }}
        {...fieldProps}
      />
    );
  }

  return <Field component={TextField as any} {...fieldProps} />;
};

export default DynamicField;
